var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { t, Translate } from "../../I18N";

import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";
import PropertyConfigOptions from "./PropertyConfigOptions";






const mapStateToProps = (state, ownProps) => {
  const { template } = state;
  return {
    property: template.data.properties ? template.data.properties[ownProps.index] : undefined,
    index: ownProps.index,
    type: ownProps.type,
    labelHasError: checkErrorsOnLabel(state, ownProps)
  };
};

const connector = connect(mapStateToProps);



const FormConfigDateComponent = ({ index, type, labelHasError, property }) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
_jsx("label", { htmlFor: "property-label" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Label")
), /*#__PURE__*/
_jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
_jsx("input", { className: "form-control", id: "property-label" })
)
), /*#__PURE__*/

_jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
_jsx("label", { htmlFor: "property-type" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Type")
), /*#__PURE__*/
_jsx("span", { className: "property-type-warning" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "This cannot be changed after saving")
), /*#__PURE__*/
_jsx(Field, { model: `template.data.properties[${index}].type` }, void 0, /*#__PURE__*/
_jsx("select", { name: "type", id: "property-type", className: "form-control", disabled: !!(property !== null && property !== void 0 && property._id) }, void 0, /*#__PURE__*/
_jsx("option", { value: "date" }, void 0, t('System', 'Single date', null, false)), /*#__PURE__*/
_jsx("option", { value: "multidate" }, void 0, t('System', 'Multiple date', null, false)), /*#__PURE__*/
_jsx("option", { value: "daterange" }, void 0, t('System', 'Single date range', null, false)), /*#__PURE__*/
_jsx("option", { value: "multidaterange" }, void 0, t('System', 'Multiple date range', null, false))
)
)
), /*#__PURE__*/

_jsx(PropertyConfigOptions, { index: index, type: type, canBeFilter: true })
);


const container = connector(FormConfigDateComponent);
export { container as FormConfigDate };